import styled from 'styled-components';

export const AggregatedInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  h4 {
    margin: 5px;
    font-size: 20px;
  }
`;
